// extracted by mini-css-extract-plugin
export default {"productVideosContainer":"ProductVideos_productVideosContainer__f5vER"};